import { subscribeScrollMessages, broadcastScrollMessages } from './scrollMessages';

export default {
  subscribeScrollMessages,
  broadcastScrollMessages,
};
